export const SUPPORT_CATEGORIES = ['account', 'cv', 'billing', 'jobs', 'other'] as const;
export type SupportCategory = (typeof SUPPORT_CATEGORIES)[number];
export interface SupportRequestInput {
  category: SupportCategory;
  message: string;
  idempotencyKey: string;
  platform: 'ios' | 'android' | 'web';
  locale: 'en' | 'ar';
  appVersion?: string;
}
export interface SupportReplyInput {
  message: string;
  idempotencyKey: string;
}
export interface SupportConversation {
  id: string;
  category: SupportCategory;
  subject: string | null;
  status: 'open' | 'closed';
  updatedAt: string;
  lastMessageAt: string;
}
export interface SupportMessage {
  id: string;
  author: 'customer' | 'support';
  message: string;
  createdAt: string;
}
export interface SupportConversationDetail extends SupportConversation {
  messages: SupportMessage[];
  nextBefore: string | null;
}
export interface SupportConversationList {
  items: SupportConversation[];
  nextBefore: string | null;
}
